import { httpClient } from '../httpClient';
export class InvitationUmobiledRepository {
    constructor() {
        this.basePath = 'invitation/umobiled';
    }
    async notifyUrl(params) {
        const { data } = await httpClient.post(`${this.basePath}/notify-url`, JSON.stringify(params));
        return data;
    }
    async verifyAccessToken(params) {
        const { data } = await httpClient.post(`${this.basePath}/verify-access-token`, JSON.stringify(params));
        return data;
    }
    async verifyInvitationCode(params) {
        const { data } = await httpClient.post(`${this.basePath}/verify-invitation-code`, JSON.stringify(params));
        return data;
    }
    async registerInvitationTransferApplication(params) {
        const { data } = await httpClient.post(`${this.basePath}/register-invitation-transfer-application`, JSON.stringify(params));
        return data;
    }
    async fetchRegisteredInvitationTransferApplication(params) {
        const { data } = await httpClient.post(`${this.basePath}/fetch-registered-invitation-transfer-application`, JSON.stringify(params));
        return data;
    }
    async analyzeEncryptedSlnData(params) {
        const { data } = await httpClient.post(`${this.basePath}/analyze-encrypted-sln-data`, JSON.stringify(params));
        return data;
    }
    async handleMnpPortinActivation(params) {
        const { data } = await httpClient.post(`${this.basePath}/handle-mnp-portin-activation`, JSON.stringify(params));
        return data;
    }
}
